<template>
  <div id="minimap-wrapper" style="background:white;height:300px!important;width:300px!important;">
  map
  </div>
</template>

<script>
export default {
  name: 'MiniMap',
  data() {
        return {
			roofs:[],
			lastAlert: 0,
			mapData: ''
		}
  },
  methods: {
      nextPage() {
		  if(document.getElementById("mapData").innerHTML != ''){
        this.$emit('nextPage', this.roofs);
		  }
      },
      hideCalc() {
        this.$emit('hideCalc');
      },
  updateWindow: function(layer){
var features = layer.getSource().getFeatures();
if(features.length > 3){
if(Date.now() - this.lastAlert > 100){
alert("Du kan välja max 3 tak");
this.lastAlert = Date.now();
}
var id = features[3].getId();
this.origo.api().getSelectionManager().removeItemById(id);
features = features.slice(0,3);
}
this.roofs = features.map(feature => {
var returnedObj = feature.getProperties();
returnedObj.id = feature.getId();
return returnedObj;
});
if(features.length === 0){
this.mapData = '';
//document.getElementById("mapData").innerHTML = '';
} else {
this.mapData = features.length + ' tak. Totalt ' + features.reduce(this.summit, 0) + 'm<sup>2</sup><br />';
//document.getElementById("mapData").innerHTML = features.length + ' tak. Totalt ' + features.reduce(this.summit, 0) + 'm<sup>2</sup><br />';
}
document.getElementById("sidebarcontainer").style.display = 'none';
if(features.length === 0){
this.clearSelection()
}
},

	summit: function(total, feature) {
  return total + Math.round(feature.get('area_slope'));
},
	  clearSelection: function() {
  this.origo.api().getSelectionManager().clearSelection();
  this.hideCalc();
}
  },
	mounted: function(){
	this.minimap = Origo('./index.json', { target: '#minimap-wrapper' });
	},
    created() {
        this.$root.$refs.MiniMap = this;
    }
}
</script>

<style src="./style.css"></style>